import Service from "../../../Services/index";

const FactorialMaterialImport = {
    namespaced: true,
    state: {
        factorialMaterialImportList: [],
        form: {
            id: "",
            factorial_id: "",
            user_id: "",
            quantity: "",
            source_id: "",
            onSave: false,
            note: ''
        },
        search: {
            name: "",
            source_id: "",
            date: ""
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_FACTORIAL_MATERIAL_IMPORT: (state, res) => {
            state.factorialMaterialImportList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_FACTORIAL_MATERIAL_IMPORT_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA: (state) => {
            state.form = {
                id: "",
                factorial_id: "",
                user_id: "",
                quantity: "",
                source_id: "",
                onSave: false,
                note: ''
            }
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                name: "",
                source_id: "",
                date: ""
            }
        }
    },
    actions: {
        setFactorialMaterialImport({commit}, page = 1) {
            return Service.FactorialMaterialImport.getFactorialMaterialImport(page).then(data => {
                commit("GET_FACTORIAL_MATERIAL_IMPORT", data);
            });
        },
        saveFactorialMaterialImport({commit}, data) {
            if (!data.id) {
                return Service.FactorialMaterialImport.createFactorialMaterialImport(data).then(res => {
                    //console.log("create");
                });
            } else {
                return Service.FactorialMaterialImport.updateFactorialMaterialImport(data.id, data).then(res => {
                    //console.log("update");
                });
            }
        },
        showFactorialMaterialImportByID({commit}, id) {
            return Service.FactorialMaterialImport.showFactorialMaterialImport(id).then(res => {
                commit("GET_FACTORIAL_MATERIAL_IMPORT_BY_ID", res);
                return res;
            })
        },
        delete({commit}, id) {
            //console.log('module')
            //console.log(id)
            return Service.FactorialMaterialImport.deleteFactorialMaterialImport(id)
                .catch(err => {
                    console.error(err);
                });
        },
        search({commit}, data) {
            return Service.FactorialMaterialImport.searchFactorialMaterialImport(data).then(res => {
                commit("GET_FACTORIAL_MATERIAL_IMPORT", res)
            })
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default FactorialMaterialImport;
